export default "__VITE_ASSET__Dr5qmkme__"